import * as THREE from 'three';

export default class PointSystem {

    constructor({

        count = 220,

        width = 18,

        height = 10,

        depth = 8,

        speed = 0.01

    } = {}) {

        this.count = count;

        this.width = width;
        this.height = height;
        this.depth = depth;

        this.speed = speed;

        this.points = [];

        this.positions = new Float32Array(
            this.count * 3
        );
        this.scales = new Float32Array(
            this.count
        );

        this.generate();

    }

    generate() {

        this.points.length = 0;

     for (let i = 0; i < this.count; i++) {
        
            const point = {
        
                position: new THREE.Vector3(
        
                    (Math.random() - 0.5) * this.width,
                    (Math.random() - 0.5) * this.height,
                    (Math.random() - 0.5) * this.depth
        
                ),
        
                velocity: new THREE.Vector3(
        
                    (Math.random() - 0.5) * this.speed,
                    (Math.random() - 0.5) * this.speed,
                    (Math.random() - 0.5) * this.speed
        
                )
        
            };
        
            this.points.push(point);
        
            this.scales[i] =
    0.3 + Math.random() * 2.7;
        }

        this.updatePositions();

    }

    update(delta = 1) {

        for (const point of this.points) {

            point.position.addScaledVector(
                point.velocity,
                delta * 60
            );

            if (Math.abs(point.position.x) > this.width / 2)
                point.velocity.x *= -1;

            if (Math.abs(point.position.y) > this.height / 2)
                point.velocity.y *= -1;

            if (Math.abs(point.position.z) > this.depth / 2)
                point.velocity.z *= -1;

        }

        this.updatePositions();

    }

    updatePositions() {

        let i = 0;

        for (const point of this.points) {

            this.positions[i++] = point.position.x;
            this.positions[i++] = point.position.y;
            this.positions[i++] = point.position.z;

        }

    }

    getPoints() {

        return this.points;

    }

    getPositions() {

        return this.positions;

    }
	getScales() {
	
	    return this.scales;
	
	}
}
